<template>
  <component :is="component" v-model="value" :prop="prop" :model="model" :readonly="readonly"></component>
</template>

<style scoped>

</style>

<script>
  import GhInput from "./ghInput.ts";
  export default GhInput;
</script>